import { Component, computed, effect, inject, Signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { Event } from '../../../../models/event.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { EventStoreService } from 'src/app/services/stores/event.store.service';
import { ShoutoutsStoreService } from 'src/app/services/stores/shoutouts.store.service';

@Component({
  selector: 'app-shoutouts',
  templateUrl: './shoutouts.component.html',
  styleUrls: ['./shoutouts.component.scss'],
  standalone: false,
  providers: [ShoutoutsStoreService],
})
export class ShoutoutsComponent {
  private _route: ActivatedRoute = inject(ActivatedRoute);
  private _eventStoreService = inject(EventStoreService);
  private _queryParams: Signal<any> = toSignal(this._route.queryParams);
  private _routeData: Signal<any> = toSignal(this._route.data);
  protected shoutoutsStoreService = inject(ShoutoutsStoreService);
  protected getProductName = computed(() => {
    return (productId: string) => {
      const event = this._eventStoreService.event();
      if (!event || !event.products) return 'Unknown';
      const product = event.products.find((p) => p.id === productId);
      return product ? product.name : 'Unknown';
    };
  });

  event!: Event;
  user!: User;
  displayedColumns: string[] = [
    'sent time',
    'from',
    'to',
    'product',
    'message',
    'actions',
  ];

  constructor() {
    effect(() => {
      const sessionId = this._queryParams().sessionId
        ? this._queryParams().sessionId
        : null;
      const productId = this._queryParams().productId
        ? this._queryParams().productId
        : null;
      const { paid, moderated, approved, announced } = this._routeData();
      const event = this._eventStoreService.event();
      this.shoutoutsStoreService.get(
        event?.id!,
        sessionId,
        paid,
        announced,
        moderated,
        approved,
        productId,
      );
    });
  }
}
